import { render, staticRenderFns } from "./DeliveryShow.vue?vue&type=template&id=783b5746&"
import script from "./DeliveryShow.vue?vue&type=script&lang=js&"
export * from "./DeliveryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports